import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {RequestBody} from "../../entity/core/request-body";
import {InvoiceRequest} from "../../entity/model/invoice-request";

export default class InvoiceRequestAgent {
    createInvoiceTemplate = async (organizationId: string, requestBody: RequestBody): Promise<InvoiceRequest> => {
        return API.post(awsApiName, `/organizations/${organizationId}/invoice-templates`, requestBody);
    }

    updateInvoiceTemplate = async (organizationId: string, templateId: string, requestBody: RequestBody): Promise<InvoiceRequest> => {
        return API.patch(awsApiName, `/organizations/${organizationId}/invoice-templates/${templateId}`, requestBody);
    }

    getInvoiceTemplates = async (organizationId: string, titleId: string): Promise<InvoiceRequest[]> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/invoice-templates?projectTitleID=${titleId}`, {});
    }

}
